module.exports = __webpack_public_path__ + "img/g9.3fca9d1c.jpg";